function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M371.44 1.47998C339.62 1.47998 317.59 24.57 317.59 56.38C317.59 88.19 338.34 111.86 374.81 111.86C391.12 111.86 405.39 107.9 416.83 99.02L403.97 75.48C395.57 81.31 386.53 84.59 376.2 84.59C362.47 84.59 354.37 78.32 351.27 67.43H421.42C422.02 64.27 422.55 58.12 422.5 52.65C422.31 30.01 410.38 1.47998 371.44 1.47998ZM351 45.13C353.57 34.53 360.31 27.3 371.54 27.3C382.24 27.3 389.98 33.55 390.87 45.13H351Z",
  fill: "#FF7D00"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M703.26 97.8398C699.57 97.8398 696.49 100.71 696.49 104.53C696.49 108.39 699.57 111.27 703.26 111.27C706.92 111.27 710 108.39 710 104.53C710 100.71 706.93 97.8398 703.26 97.8398ZM707.76 108.56H707.25C706.26 109.63 704.85 110.29 703.26 110.29C700.1 110.29 697.71 107.82 697.71 104.54C697.71 101.31 700.1 98.8398 703.26 98.8398C706.36 98.8398 708.77 101.31 708.77 104.54C708.77 105.98 708.31 107.26 707.53 108.25L707.76 108.56Z",
  fill: "#FF7D00"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M488.17 5.34985L467.51 49.8799L447.73 5.34985H411.98L450.15 81.4299V110.48H484.46V81.4699L524.61 5.34985H488.17Z",
  fill: "#FF7D00"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M42.19 0.159937C29.89 -0.420063 8.93 0.729937 0 1.38994L0.72 27.9999L9.27 27.4599V110.36H42.23V89.6499C90.39 87.3499 101.65 61.6599 101.65 43.5399C101.64 17.8399 80.69 1.96994 42.19 0.159937ZM42.23 63.8099V27.5899C63.23 28.5799 68.28 37.5599 68.28 44.8799C68.27 55.2799 61.3 63.4199 42.23 63.8099Z",
  fill: "#FF7D00"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M565.26 1.47998C533.44 1.47998 511.41 24.57 511.41 56.38C511.41 88.19 532.65 111.86 568.34 111.86C583.21 111.86 596.13 108.62 606.97 101.27L595.11 76.88C587.35 81.87 579.2 84.58 569.73 84.58C556.59 84.58 548.35 78.31 545.15 67.42H615.23C615.83 64.26 616.38 58.11 616.33 52.64C616.12 30.01 604.2 1.47998 565.26 1.47998ZM544.82 45.13C547.39 34.53 554.13 27.3 565.36 27.3C576.06 27.3 583.88 33.66 584.69 45.13H544.82Z",
  fill: "#FF7D00"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M159.97 2.13989C129.7 2.13989 104.52 24.6199 104.52 56.4999C104.52 88.3799 129.7 110.86 159.97 110.86C190.24 110.86 215.42 88.3899 215.42 56.4999C215.42 24.6199 190.24 2.13989 159.97 2.13989ZM160.22 81.6999C145.51 81.6999 136.19 70.3899 136.19 56.2999C136.19 42.2099 145.52 30.8899 160.22 30.8899C174.93 30.8899 184.25 42.1999 184.25 56.2999C184.25 70.3799 174.93 81.6999 160.22 81.6999Z",
  fill: "#FF7D00"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M256.08 1.24992C243.9 0.679915 223.14 1.80992 214.31 2.46992L215.02 28.8199L223.49 28.2899V110.37H256.12V89.8599C303.81 87.5799 314.95 62.1499 314.95 44.2099C314.94 18.7499 294.2 3.03992 256.08 1.24992ZM256.11 64.2699V28.3999C276.9 29.3799 281.9 38.2699 281.9 45.5199C281.9 55.8299 275 63.8799 256.11 64.2699Z",
  fill: "#FF7D00"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M673.88 47.9199C668 45.5499 660.92 42.9299 656.31 40.8299C651.8 38.7799 650.21 36.7399 650.21 33.6299C650.21 29.5099 654.47 27.2599 659.89 27.2599C668.19 27.2599 674.67 31.0899 680.49 37.3099L698.76 18.3099C690.93 7.75986 677.48 1.10986 660.31 1.10986C637.05 1.10986 618.9 12.3299 618.9 34.4599C618.9 51.9399 627.33 60.3399 643.68 67.4199C648.32 69.4299 654.53 71.2099 659.18 73.1899C663.24 74.9099 665.79 76.7399 665.79 80.0699C665.79 83.1599 663.08 85.6699 655.23 85.6699C647.99 85.6699 637.56 82.7599 629.97 77.8299L618.86 100.59C629.43 108.24 642.2 111.38 655.26 111.38C675.54 111.38 697.28 102.6 697.28 78.9899C697.28 61.2199 685.9 52.7699 673.88 47.9199Z",
  fill: "#FF7D00"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M707.73 102.98C707.73 101.24 706.38 100.64 704.01 100.64H700.44V108.56H702.29V105.17H703.49L705.82 108.56H707.26C707.35 108.46 707.45 108.35 707.54 108.24L705.24 105.1C706.63 104.99 707.73 104.44 707.73 102.98ZM702.29 103.95V101.86H703.89C704.77 101.86 705.84 101.99 705.84 102.85C705.84 103.82 705.04 103.94 703.98 103.94H702.29V103.95Z",
  fill: "#FF7D00"
});

function SvgPlkWordmarkLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 710,
    height: 112,
    viewBox: "0 0 710 112",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlkWordmarkLogo);
export default __webpack_public_path__ + "static/media/PLKWordmarkLogo.5157e5ce.svg";
export { ForwardRef as ReactComponent };